export default "__VITE_ASSET__CiKfnc$F__"